import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { CloseCircleOutline, ScheduledGift } from '@aslanpay/portal-common-lib';

import { formatScheduledAt } from 'app/utils/scheduledGifts';

import { CancelScheduledGiftModalProps } from './types';

// Names the gift being cancelled, e.g. "The gift to 24 employees on Fri 6 Nov 2026, 09:00 won't be sent."
const describeGift = (gift?: ScheduledGift) => {
  if (gift) {
    const people = gift.recipientCount === 1 ? 'employee' : 'employees';
    return `The gift to ${gift.recipientCount} ${people} on ${formatScheduledAt(
      gift.scheduledAt
    )} won't be sent. `;
  }
  return '';
};

function CancelScheduledGiftModal({
  isOpen,
  onClose,
  gift,
  isCancelling,
  onConfirm,
}: CancelScheduledGiftModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent
        w={{ base: '100vw', sm: '560px' }}
        maxW={{ base: '100vw', sm: '560px' }}
        data-testid="cancel-scheduled-gift-modal"
      >
        <ModalHeader>
          <HStack>
            <Text textStyle="h4" fontSize="18px" fontWeight="600">
              Cancel this gift?
            </Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close cancel gift modal"
              onClick={onClose}
              isDisabled={isCancelling}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text textStyle="smallMedium" textColor="brand.darkGray">
            {describeGift(gift)}
            It stays in the list as cancelled, and no points leave the company balance.
          </Text>
        </ModalBody>
        <ModalFooter gap="12px">
          <Button
            variant="outline"
            onClick={onClose}
            isDisabled={isCancelling}
            data-testid="keep-scheduled-gift-button"
          >
            Keep gift
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            isLoading={isCancelling}
            data-testid="confirm-cancel-scheduled-gift-button"
          >
            Cancel gift
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CancelScheduledGiftModal;
